import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminLocalization from "@/pages/admin/AdminLocalization";

export const Route = createFileRoute("/admin/localizacao")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminLocalization />
    </AdminRoute>
  ),
});
